import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { SuggestedPackage, StoreItem } from "../../types/types";

let initialState:StoreItem<SuggestedPackage[]>={
    requestStatus:"not_initiated",
    responseStatus:"not_recieved",
    haveAnIssue:false,
    issue:"",
    data:[]
}

export const SuggestedPackageSlice=createSlice({
    name:'SuggestedPackage',
    initialState:initialState,
    reducers:{
        initSuggestedPackage:(state,action:PayloadAction<StoreItem<SuggestedPackage[]>>)=>({...action.payload}),
        addSuggestedPackage:(state,action:PayloadAction<SuggestedPackage>)=>{state.data.push(action.payload)},
        setSuggestedPackage:(state,action:PayloadAction<SuggestedPackage[]>)=>{state.data=action.payload},
        updateSuggestedPackage:(state,action:PayloadAction<SuggestedPackage>)=>{
            let index=state.data.findIndex((item)=>item._id===action.payload._id);
            state.data[index]=action.payload;
        },
        //  removeSuggestedPackage:(state,action:PayloadAction<string>)=>{state.data=state.data.filter((item)=>item._id!==action.payload)},
        resetSuggestedPackage:(state,action:PayloadAction)=>({...initialState})

    }
})

export const {initSuggestedPackage,addSuggestedPackage,resetSuggestedPackage,setSuggestedPackage,updateSuggestedPackage}=SuggestedPackageSlice.actions;
export default SuggestedPackageSlice.reducer;